import {Component,Inject} from 'ng-metadata/core';
import {SearchFieldsService} from '../../../search.fields.service';
import {STATE_NAMES} from '../../../../primoExplore/primoExploreStates.module';

@Component({
    selector: 'prm-ngrs-results-button',
    templateUrl: 'components/search/fullView/ngrs/resultsButton/ngrs-results-button.html'
})

export class PrmNgrsResultsButton {   
    
    
    constructor(@Inject('$state') private $state: angular.ui.IStateService,
    private searchFieldsService: SearchFieldsService) {       
    }

    changeSearchScope(){   
        let state = STATE_NAMES.SEARCH;
        this.searchFieldsService.searchParams.search_scope='RapidXL';
        this.searchFieldsService.searchParams.tab='RAPIDXL';
        this.$state.go(state, this.searchFieldsService.searchParams , {reload: false});
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/resultsButton/ngrsResultsButton.directive.ts